<div [ngClass]="{'is-last': isLast()}"
     class="news-wrapper">
  <a [href]="HELPER.getUrl(relatedItem().sourceUrl)">
    <div class="tag-wrapper">
      <app-color-tag [tagTitle]="relatedItem().type | translate " [withBMargin]="false"></app-color-tag>
      <app-divider></app-divider>
      <app-is-new-tag [newsDate]="(relatedItem().publishDate || relatedItem().date) | onlyDate"></app-is-new-tag>
    </div>

    <div class="news-title">{{ relatedItem().title }}</div>
    <div [innerHTML]="description() | removeHtml" class="news-description"></div>
  </a>


</div>
